module.exports = __webpack_public_path__ + "static/media/Banglow.389bb9af.jpg";